import { useAppSelector } from "@sso/hooks/useRedux";
import { selectOrderQuery } from "@sso/store/slices/order";

import { useOrdersQuery } from "../order";

export const useGetOrdersQuery = () => {
  const queryParams = useAppSelector(selectOrderQuery);
  return useOrdersQuery(queryParams);
};
